import { ScheduleItemV2 } from '@hopin-team/api-hopin';

import { Organiser } from '../types';

export const mockScheduleItems: ScheduleItemV2[] = [
  {
    id: 1,
    external_id: '1cyVlUOHx5Br3a7k9VO6iuHPd',
    external_url: '',
    event_name: 'drOne',
    name: 'Intro Session',
    description: '',
    time_start: '2021-06-07T09:00:00Z',
    time_end: '2021-06-07T10:00:00Z',
    event_part_type: 'expo',
    event_type: 'virtual',
    room: null,
    capacity: null,
    attendance: 'recommended',
    speakers: [
      {
        id: 1,
        external_id: '1',
        user_external_id: null,
        name: 'Finlay Smith',
        email: 'finlay.smith@hopin.com',
        headline: 'Senior FE Engineer @ Hopin',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/fs.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/fs.svg',
        linkedin: 'https://linkedin.com/fin',
        twitter: 'https://twitter.com/fin',
        website: 'https://hopin.com/fin',
      },
      {
        id: 2,
        external_id: '2',
        user_external_id: 'uuid',
        name: 'David Robins',
        email: 'david.robins@hopin.com',
        headline: '',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/dr.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/dr.svg',
        linkedin: null,
        twitter: null,
        website: null,
      },
      {
        id: 3,
        external_id: '3',
        user_external_id: 'uuid',
        name: 'Youssef Meskini',
        email: 'youssef@hopin.com',
        headline: '',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/ym.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/ym.svg',
        linkedin: null,
        twitter: null,
        website: null,
      },
      {
        id: 4,
        external_id: '4',
        user_external_id: null,
        name: 'Sasha Pronina',
        email: 'sasha@hopin.com',
        headline: '',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/sp.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/sp.svg',
        linkedin: null,
        twitter: null,
        website: null,
      },
      {
        id: 5,
        external_id: '5',
        user_external_id: 'uuid',
        name: 'Kate Kirby',
        email: 'kate@hopin.com',
        headline: '',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/kk.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/kk.svg',
        linkedin: null,
        twitter: null,
        website: null,
      },
      {
        id: 6,
        external_id: '6',
        user_external_id: 'uuid',
        name: 'Francis Perez',
        email: 'francis@hopin.com',
        headline: '',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/fp.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/fp.svg',
        linkedin: null,
        twitter: null,
        website: null,
      },
      {
        id: 7,
        external_id: '7',
        user_external_id: 'uuid',
        name: 'Colin Caraher',
        email: 'colin@hopin.com',
        headline: '',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/cc.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/cc.svg',
        linkedin: null,
        twitter: null,
        website: null,
      },
      {
        id: 8,
        external_id: '8',
        user_external_id: 'uuid',
        name: 'Ladyslaw Wlodarski',
        email: 'ladyslaw@hopin.com',
        headline: '',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/lw.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/lw.svg',
        linkedin: null,
        twitter: null,
        website: null,
      },
    ],
    current_user_is_speaker: false,
    tags: [{ id: 1, name: 'Wonderful' }],
    draft: false,
    picture_url: null,
    thumb_picture_url: null,
  },
  {
    id: 2,
    external_id: 'zFC4Po4HMq1v4XQPpWahDtt6k',
    external_url: '',
    event_name: 'drOne',
    name: 'Networking Session',
    description: '',
    time_start: '2021-06-07T13:00:00Z',
    time_end: '2021-06-07T14:00:00Z',
    event_part_type: 'networking',
    event_type: 'virtual',
    room: null,
    capacity: null,
    speakers: [],
    current_user_is_speaker: false,
    tags: [],
    draft: false,
    picture_url: null,
    thumb_picture_url: null,
  },
  {
    id: 3,
    external_id: 'hZryCrQ1vv8i18eLwHZkNLJ4E',
    external_url: '',
    event_name: 'drOne',
    name: 'Shutdown Sessions',
    description:
      'Donec quis nulla id arcu eleifend volutpat ut id justo. Integer enim sapien, maximus in cursus at, condimentum sit amet nunc. Pellentesque ligula ligula, rutrum sit amet magna vitae',
    time_start: '2021-06-07T16:00:00Z',
    time_end: '2021-06-07T17:00:00Z',
    event_part_type: 'custom',
    event_type: 'virtual',
    room: null,
    capacity: null,
    speakers: [],
    current_user_is_speaker: false,
    tags: [{ id: 2, name: 'Nice' }],
    draft: false,
    picture_url: null,
    thumb_picture_url: null,
  },
  {
    id: 4,
    external_id: 'XqFtXXUy1f7mHXR6mp40dHjwM',
    external_url: '',
    event_name: 'drOne',
    name: 'Optimization and Performance',
    description: 'Short description',
    time_start: '2021-06-08T09:00:00Z',
    time_end: '2021-06-08T11:00:00Z',
    event_part_type: 'stage',
    event_type: 'virtual',
    room: null,
    capacity: null,
    stage: {
      id: 1,
      name: 'Stage',
    },
    speakers: [
      {
        id: 1,
        external_id: '1',
        user_external_id: null,
        name: 'Finlay Smith',
        email: 'finlay.smith@hopin.com',
        headline: 'Senior FE Engineer @ Hopin',
        picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/fs.svg',
        thumb_picture_url:
          'https://quiin.s3.amazonaws.com/default_images/avatars/fs.svg',
        linkedin: 'https://linkedin.com/fin',
        twitter: 'https://twitter.com/fin',
        website: 'https://hopin.com/fin',
      },
    ],
    current_user_is_speaker: false,
    tags: [{ id: 1, name: 'Wonderful' }],
    draft: false,
    picture_url: null,
    thumb_picture_url: null,
  },
];

export const mockOrganiser: Organiser = {
  id: 1,
  external_id: 'ABC123',
  name: 'My Mock Org',
  status: 'live',
  organiser_id: 1234,
  organiser_external_id: 'DEF456',
  custom_event_part_title: 'Chat Cafe',
  custom_event_part_url: 'https://hopin.com',
  venue_type: 'virtual',
  schedule_draft: false,
  is_lite: false,
};
